{
    "invoiceTableConfig": [
      {
        "label": "invoiceNo",
        "displayLabel": "Invoice No",
        "editable": false,
        "isPinned": true
      },
      {
        "label": "invoiceDate",
        "displayLabel": "Invoice Date",
        "editable": false,
        "fieldInfo": {
          "dataType": "DATE"
        }
      },
      {
        "label": "billingParty.name",
        "displayLabel": "Billing Party",
        "editable": false
      },
      {
        "label": "paymentTerm",
        "displayLabel": "Payment Term",
        "editable": false
      },
      {
        "label": "amount.totalAmount",
        "displayLabel": "Total Amount",
        "editable": false
      },
      {
        "label": "dueAmount",
        "displayLabel": "Due Amount",
        "editable": false
      },
      {
        "label": "tdsAmount",
        "displayLabel": "TDS Amount",
        "placeholder": "Enter Amount",
        "editable": true,
        "conditionalEditable": true,
        "dependsOn": "tdsApplicable",
        "fieldInfo": {
          "dataType": "number"
        }
      },
      {
        "label": "tanNo",
        "displayLabel": "TAN No.",
        "editable": false
      },
      {
        "label": "writeOffAmount",
        "displayLabel": "Write Off",
        "placeholder": "Enter Amount",
        "editable": true,
        "fieldInfo": {
          "dataType": "number"
        }
      },
      {
        "label": "amountPaid",
        "displayLabel": "Amount Paid",
        "placeholder": "Enter Amount",
        "editable": true,
        "fieldInfo": {
          "dataType": "number"
        }
      }
  ],

  "transcationFormControls": {
      "formRows": [
            {
                "formGroups": [
                  {
                    "style": {
                        "gridColumn": "span 2"
                    },
                    "control": {
                        "label": "paymentMode",
                        "displayLabel": "Mode Of Payment",
                        "placeHolder": "Select Payment Mode",
                        "fieldInfo": {
                            "dataType": "select",
                            "options": []
                        },
                        "validators": [
                          {
                              "type": "selectRequired",
                              "message": "Payment Mode is required"
                          }
                        ]
                    }
                  },
                  {
                    "style": {
                        "gridColumn": "span 2"
                    },
                    "control": {
                        "label": "amount",
                        "displayLabel": "Amount",
                        "placeHolder": "Enter Amount",
                        "fieldInfo": {
                            "dataType": "number"
                        },
                        "validators": [
                          {
                              "type": "required",
                              "message": "Amount is required"
                          }
                        ]
                    }
                  },
                  {
                    "style": {
                        "gridColumn": "span 2"
                    },
                    "control": {
                        "label": "instrumentNumber",
                        "displayLabel": "Instrument No",
                        "placeHolder": "Enter Instrument No",
                        "fieldInfo": {
                            "dataType": "text"
                        },
                        "validators": [
                          {
                              "type": "required",
                              "message": "Instrument No is required"
                          }
                        ]
                    }
                  },
                  {
                    "style": {
                        "gridColumn": "span 2"
                    },
                    "control": {
                        "label": "transactionDate",
                        "displayLabel": "Instrument Date",
                        "placeHolder": "Select Instrument Date",
                        "fieldInfo": {
                            "dataType": "date"
                        },
                        "validators": [
                          {
                              "type": "required",
                              "message": "Instrument Date is required"
                          }
                        ]
                    }
                  }
                ]
            },

            {
                "formGroups":[
                  {
                    "style": {
                        "gridColumn": "span 2"
                    },
                    "control": {
                        "label": "payerBankName",
                        "displayLabel": "Payer Bank",
                        "placeHolder": "Select Bank",
                        "fieldInfo": {
                            "dataType": "select",
                            "options": []
                        },
                        "validators": [
                          {
                              "type": "selectRequired",
                              "message": "Payer Bank is required",
                              "conditions": {
                                "logic": "AND",
                                "rules": [
                                  { "field": "paymentMode", "operator": "IN", "value": ["NEFT", "RTGS"] }
                                ]
                              }
                          }
                        ]
                    }
                  },
                  {
                    "style": {
                        "gridColumn": "span 2"
                    },
                    "control": {
                        "label": "payerBank",
                        "displayLabel": "Payer Bank Branch",
                        "placeHolder": "Select Branch",
                        "fieldInfo": {
                            "dataType": "select",
                            "options": []
                        },
                        "validators": [
                          {
                              "type": "selectRequired",
                              "message": "Payer Branch is required",
                              "conditions": {
                                "logic": "AND",
                                "rules": [
                                  { "field": "paymentMode", "operator": "IN", "value": ["NEFT", "RTGS"] }
                                ]
                              }
                          }
                        ]
                    }
                  },
                  {
                    "style": {
                        "gridColumn": "span 2"
                    },
                    "control": {
                        "label": "receivingBankName",
                        "displayLabel": "Receiving Bank",
                        "placeHolder": "Select Bank",
                        "fieldInfo": {
                            "dataType": "select",
                            "options": []
                        },
                        "validators": [
                          {
                              "type": "selectRequired",
                              "message": "Receiving Bank is required",
                              "conditions": {
                                "logic": "AND",
                                "rules": [
                                  { "field": "paymentMode", "operator": "IN", "value": ["NEFT", "RTGS"] }
                                ]
                              }
                          }
                        ]
                    }
                  },
                  {
                    "style": {
                        "gridColumn": "span 2"
                    },
                    "control": {
                        "label": "receivingBank",
                        "displayLabel": "Receiving Bank Branch",
                        "placeHolder": "Select Branch",
                        "fieldInfo": {
                            "dataType": "select",
                            "options": []
                        },
                        "validators": [
                          {
                              "type": "selectRequired",
                              "message": "Receiving Branch is required",
                              "conditions": {
                                "logic": "AND",
                                "rules": [
                                  { "field": "paymentMode", "operator": "IN", "value": ["NEFT", "RTGS"] }
                                ]
                              }
                          }
                        ]
                    }
                  }
                ]
            }
        ]
  },

  "paymentFormControls": {
      "formRows": [
          {
              "formGroups": [
                {
                  "style": {
                      "gridColumn": "span 2"
                  },
                  "control": {
                      "label": "paymentDate",
                      "displayLabel": "Receipt Date",
                      "placeHolder": "Select Date",
                      "fieldInfo": {
                          "dataType": "datetime-local"
                      },
                      "validators": [
                          {
                              "type": "required",
                              "message": "Receipt Date is required"
                          }
                        ]
                  }
                },
                {
                  "style": {
                    "gridColumn": "span 2"
                  },
                  "control": {
                    "label": "customer",
                    "displayLabel": "Customer",
                    "placeHolder": "Select Customer",
                    "fieldInfo": {
                      "dataType": "picklist",
                      "lookupDetails": {
                        "apiUrl": "v1/customers/list",
                        "filterByKeys": ["NAME_CONTAINS"],
                        "additionalFilters": [
                          {
                            "name": "IS_ACTIVE",
                            "alias": "active",
                            "operator": "EQ",
                            "value": ["true"]
                          }
                        ],
                        "limit": 10,
                        "orderBy": { "name": "asc" },
                        "bindLabel": "name",
                        "bindValue": "id",
                        "displayColumns": [
                          { "key": "code", "header": "Code" },
                          { "key": "name", "header": "Name" }
                        ]
                      }
                    },
                    "validators": [
                      {
                          "type": "autocompleteRequired",
                          "message": "Customer is required"
                      }
                    ]
                  }
                },
                {
                  "style": {
                    "gridColumn": "span 2"
                  },
                  "control": {
                    "label": "payingParty",
                    "displayLabel": "Paying Party",
                    "placeHolder": "Select Paying Party",
                    "disabled": false,
                    "fieldInfo": {
                      "dataType": "picklist",
                      "lookupDetails": {
                        "apiUrl": "v1/customers/list",
                        "selectFields": ["id", "name", "code"],
                        "filterByKeys": ["name", "code"],
                        "limit": 10,
                        "orderBy": { "name": "asc" },
                        "filterByKey": "name",
                        "bindLabel": "name",
                        "bindValue": "id",
                        "displayColumns": [
                          { "key": "code", "header": "Code" },
                          { "key": "name", "header": "Name" }
                        ]
                      }
                    },
                    "validators": [
                      {
                          "type": "autocompleteRequired",
                          "message": "Paying Party is required"
                      }
                    ]
                  }
                }
              ]
          }
      ]
  }
}
